module.exports = __webpack_public_path__ + "img/status_6.9e72d33d.svg";